/**
 * OpenAPI definition
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Lp pair update request
 */
export interface LpPairUpdateRequest {
  qtyScale: number;
  priceScale: number;
  minQty: number;
  maxQty: number;
  lpPairId: number;
  /**
   * True - pair is active, False - pair is not activate
   */
  activate: boolean;
}
